import { useQuery } from 'react-query';

import { getComponentLiteList as queryFn } from 'api/endPoints/getComponentLiteList';
import { QueryKeys } from 'api/queryKeys';

export const useQueryGetComponentLiteList = () => {
    return useQuery<QueryResponse[], QueryError, QueryResponse[], [QueryKeys]>({
        queryKey: ['getComponentLiteList'],
        queryFn: () => queryFn(),
    });
};

export interface QueryResponse {
    id: number;
    componentKey: string;
    name: string;
}
